export class GraficoSearchParameter {
  ano: number;
  usuario: number;
  prestador: number;
  dataInicio: Date;
  dataFim: Date;

  /**
  * Método responsável por retornar o nome do mês selecionado.
  * @param mes identificar o mês passado no parâmetro
  */
  public getMes(mes: number) {
    const meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro',
      'Outubro', 'Novembro', 'Dezembro'];

    // Buscar o mês - 1 (Indice está iniciando em 0)
    return meses[mes - 1];
  }
}
